var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulkUploadDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.0603 11.8555C21.2892 11.8555 20.6627 12.482 20.6627 13.2531V17.2289H3.3374V13.2531C3.3374 12.482 2.7109 11.8555 1.93982 11.8555C1.16874 11.8555 0.542236 12.482 0.542236 13.2531V18.6024C0.542236 19.3735 1.16874 20 1.93982 20H22.0603C22.8313 20 23.4578 19.3735 23.4578 18.6024V13.2531C23.4578 12.482 22.8313 11.8555 22.0603 11.8555Z",
    fill: "#1D3679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.974 14.5783C12.7089 14.8433 12.3475 14.9879 11.986 14.9879C11.6246 14.9879 11.2631 14.8433 10.9981 14.5783L6.85349 10.4337C6.29928 9.87949 6.29928 9.01202 6.85349 8.45781C7.40771 7.90359 8.27518 7.90359 8.8294 8.45781L10.5884 10.2169L10.5884 1.39758C10.5884 0.626501 11.2149 -5.56661e-07 11.986 -4.89251e-07C12.7571 -4.2184e-07 13.3836 0.626501 13.3836 1.39758L13.3836 10.265L15.1908 8.45781C15.745 7.90359 16.6125 7.90359 17.1667 8.45781C17.721 9.01202 17.721 9.87949 17.1667 10.4337L12.974 14.5783Z",
    fill: "#1D3679"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkUploadDownload);
export default __webpack_public_path__ + "static/media/bulkUploadDownload.0b4531b15a76b4d065a23da6cf3f2c7d.svg";
export { ForwardRef as ReactComponent };